import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { AppDataContext } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { Loader } from '../Loader';
import CurrencyFormat from 'react-currency-format';
import { Modal } from 'bootstrap';
import { Helmet } from "react-helmet";

export function Pickup(props) {
	const history = useHistory();

    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);

    // this will toggle the class which shows field validation
    const [formWasValidated, setFormWasValidated] = useState(false);

    // error message at the top
    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);
    const [timeSlots, setTimeSlots] = useState([]);
    const [availableDays, setAvailableDays] = useState([]);
    const [timeZone, setTimeZone] = useState(null);
	const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
	const [selectedPickupReservationSecureId, setSelectedPickupReservationSecureId] = useState(null);


	const [email, setEmail] = useState(null);
	const [phone, setPhone] = useState(null);
	const [address1, setAddress1] = useState(null);
	const [address2, setAddress2] = useState(null);
	const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
	const [zip, setZip] = useState(null); 
	const [title, setTitle] = useState(null);
	const [invoiceNumber, setInvoiceNumber] = useState(null);

   

    useEffect(() => {
        setMessage(null);
        setSelectedTimeSlot(null);
        setAvailableDays([]);
		load();
    }, [props.randomNumberOpener]); //props.match.params.invoiceId,context.isLoggedIn]

	const load = async () => {
        const url = 'api/site/GetSchedule/' + props.invoiceId;

		const response = await netRequest(url);

        if (response.data != null) {
            if (response.data.isError) {
                setMessage(response.data.message);
            } else {
                setTimeSlots(response.data.timeSlots);
                setAvailableDays(response.data.availableDays);

                setAddress1(response.data.address1);
                setAddress2(response.data.address2);
                setCity(response.data.city);
                setState(response.data.state);
                setZip(response.data.zip);
                setPhone(response.data.phone);
                setEmail(response.data.email);
                setTitle(response.data.title);
                setInvoiceNumber(response.data.invoiceNumber);

                setTimeZone(response.data.auctionTimeZoneDisplayName);

                setSelectedPickupReservationSecureId(response.data.selectedPickupReservationSecureId);

                if (props.modalStateOpen)
                    (new Modal("#" + props.modalId)).show();                   

            }

		}
	};

	const selectTime = async (slot) => {       
      
        setSelectedTimeSlot(slot);
        
		 

    };

    const save = async () => {       
        
        if (selectedTimeSlot != null) {
            const url = 'api/site/selectTimeBlock';

            let data = {
                InvoiceSecureId: props.invoiceId,
                PickupWindowSecureId: selectedTimeSlot.securePickupWindowId,
                BlockStartTime: selectedTimeSlot.pickupDateTime,
                PickupReservationSecureId: selectedPickupReservationSecureId
            };
            setMessage(null);
            const resp = await netRequest(url, data);

            if (resp.isError) {
                setMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
            } else {
                if (resp.data.message != null) {
                    setMessage(resp.data.message);
                    await load();
                }
                else {
                    if (props.notifySlotSelected) {
                        props.notifySlotSelected(selectedTimeSlot.pickupDateTimeLocalStr);
                    }

                    Modal.getInstance("#" + props.modalId).hide();

                }

            }
        } else {
            Modal.getInstance("#" + props.modalId).hide();
        }

	};
     


    return (
        <>
            <div class="modal fade" id={props.modalId} aria-labelledby="pickupModal" aria-hidden="true">
                <div className={"modal-dialog modal-xl modal-fullscreen-lg-down modal-dialog-centered modal-dialog-scrollable"}>
                    <div class="modal-content">
                        <div class="modal-header pb-0">

                        
                            <h4 class="auction-grid-header">Schedule Pickup for Invoice #{invoiceNumber}</h4>
                            

                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <br />
                        </div>
                        <div class="divider mt-0 ms-3"></div>
                        <div class="modal-body">
                            <div class="row mt-3 mx-0">
                                  
                                <div class="col-12 mb-1">
                                    {
                                        message ? <div class="alert alert-danger">{message}</div> : ""
                                    }
                                </div>


                                <div class="col-12 col-md-6 mb-3">
                                    <h4 class="text-left auction-grid-header">
                                        Pickup Details
                                        <div class="divider my-2"></div>
                                    </h4>
                                    <div class="d-flex align-items-center pickup__content py-2">
                                        <div class="d-inline me-3">
                                            <i class="bi bi-pin-map"></i>
                                        </div>
                                        <div class="d-inline">
                                            <h4 class="mb-0 pb-0" >{title}</h4>
                                            <h5 class="mb-0 pb-0">{address1} {address2}</h5>
                                            <h5 class="mb-0 pb-0">{city}, {state} {zip}</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 mb-3 text-start">
                                    <h4 class="auction-grid-header">
                                        Auction Manager
                                        <div class="divider my-2"></div>
                                    </h4>
                                    <div class="d-flex align-items-center pickup__content py-2">
                                        <div class="d-inline me-3">
                                            <i class="bi bi-envelope"></i>
                                        </div>
                                        <div class="d-inline">
                                            <h4 class="mb-0 pb-0" >Email</h4>
                                            <h5 class="mb-0 pb-0"><a href={"mailto:" + email} title="example@email.com">{email}</a></h5>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center pickup__content py-2">
                                        <div class="d-inline me-3">
                                            <i class="bi bi-phone"></i>
                                        </div>
                                        {phone &&
                                            <div class="d-inline">
                                                <h4 class="mb-0 pb-0" >Phone</h4>
                                                <h5 class="mb-0 pb-0"><a href={"tel:" + phone} title={phone}>
                                                    <CurrencyFormat value={phone} format="(###) ###-####" displayType={"text"} />
                                                </a></h5>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="col-12 mb-3">
                                    <p>Please select from the below available time slots</p>
                                    <div class="accordion" id="accordionExample">
                                        {availableDays.map((date, ix) => {
                                            let daySlots = timeSlots.filter(ts => ts.pickupDay == date);

                                            return (
                                                <div key={"pu-" + ix} class="accordion-item">
                                                    <h2 class="accordion-header" id="headingOne">
                                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse" + ix} aria-expanded="true" aria-controls="collapseOne">
                                                            <div class="d-flex align-items-center pickup__header">
                                                                <div class="d-inline me-2">
                                                                    <i class="bi bi-calendar-event"></i>
                                                                </div>
                                                                <div class="d-inline">
                                                                    <h4 class="mb-0 pb-0">{date}</h4>
                                                                    <h5 class="mb-0 pb-0">All times are in local time ({timeZone})</h5>
                                                                </div>
                                                                <div class="d-inline ms-3">
                                                                    <h5 class="mb-0 pb-0">{daySlots.length} slots available</h5>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </h2>
                                                    <div id={"collapse" + ix} className={"accordion-collapse collapse " + (daySlots.find(s => s.reserved) || availableDays.length === 1 ? "show" : "")} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                        <div class="accordion-body">
                                                            <div class="row">
                                                                {daySlots.map((slot, ix) => (
                                                                    <div
                                                                        key={"pub-" + ix}
                                                                        onClick={() => selectTime(slot)}
                                                                        className={"col-4 col-md-2 pickup__slot " + ((slot.reserved && selectedTimeSlot == null) || selectedTimeSlot?.pickupDateTime == slot.pickupDateTime ? " pickup__slot--selected" : "")}>
                                                                        <span>
                                                                            {slot.timeString}
                                                                        </span>
                                                                    </div>
                                                                ))}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}


                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                             
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                             

                            <button type="button" class="btn btn-primary" onClick={save}>Save</button>


                        </div>
                    </div>
                </div>
            </div>

            {/*<Loader loading={loading} />*/}


        </>
    );

}
